import type { RoleFilter, TeamMember } from "@/app/hooks/useDagStore";

/**
 * Helper function to determine if a member matches a given role filter
 */
export const matchesRoleFilter = (role: string | null, filter: RoleFilter): boolean => {
  if (filter === "All") return true;
  if (!role) return filter === "Other";

  const lowerRole = role.toLowerCase();
  const isCoreTeam = lowerRole.includes("core team");
  const isHonorary = lowerRole.includes("honorary");
  const isContractor = lowerRole.includes("contractor");

  if (filter === "Core Team - FT") {
    // Core team members who are NOT honorary
    return isCoreTeam && !isHonorary;
  }

  if (filter === "Core Team") {
    // All core team members (including honorary) + standalone honorary
    return isCoreTeam || isHonorary;
  }

  if (filter === "Contractors") {
    return isContractor;
  }

  if (filter === "Other") {
    return !isCoreTeam && !isHonorary && !isContractor;
  }

  return false;
};

/**
 * Calculate counts for each role filter category
 */
export const calculateRoleCounts = (teamMembers: TeamMember[]): Record<RoleFilter, number> => {
  const counts: Record<RoleFilter, number> = {
    All: teamMembers.length,
    "Core Team": 0,
    "Core Team - FT": 0,
    Contractors: 0,
    Other: 0,
  };

  for (const member of teamMembers) {
    if (matchesRoleFilter(member.role, "Core Team")) {
      counts["Core Team"]++;
    }
    if (matchesRoleFilter(member.role, "Core Team - FT")) {
      counts["Core Team - FT"]++;
    }
    if (matchesRoleFilter(member.role, "Contractors")) {
      counts.Contractors++;
    }
    if (matchesRoleFilter(member.role, "Other")) {
      counts.Other++;
    }
  }

  return counts;
};
